/*
 * Notification.jsx 14.08.18
 *
 * (c) 2018 ergovia GmbH
 */
import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';

import {withStyles} from '@material-ui/core/styles';

const styles = () => ({
    notificationText: {
        display: 'inline',
        fontStyle: 'italic'
    }
});

export const RedDot = () =>
    <svg height="12" width="14">
        <circle cx="6" cy="6" r="4" fill="#F6355C" />
    </svg>;

export const YellowRing = () =>
    <svg height="11" width="14">
        <circle cx="6" cy="5" r="3" fill="transparent" stroke="#FFC213" strokeWidth="2" />
    </svg>;



const Notification = withStyles(styles)(props => {

    const {classes, type, message} = props;

    return (
        <div>
            {type === 'hint' ? <YellowRing/> : <RedDot/>}
            <Typography className={classes.notificationText}>{message}</Typography>
        </div>
    );
});

Notification.propTypes = {
    type: PropTypes.oneOf(['hint', 'warning'])
};

export default withStyles(styles)(Notification);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/core/Notification.jsx